import { render, staticRenderFns } from "./MobileStatusBody.vue?vue&type=template&id=27f4a3a8&scoped=true&"
import script from "./MobileStatusBody.vue?vue&type=script&lang=js&"
export * from "./MobileStatusBody.vue?vue&type=script&lang=js&"
import style0 from "./MobileStatusBody.vue?vue&type=style&index=0&id=27f4a3a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4a3a8",
  null
  
)

export default component.exports